import { SEND_FORGOT_PASSWORD_EMAIL } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { validate_email } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import $ from 'jquery';
import OnboardingIndex from '../OnboardingIndex.vue';


export default {
  name: 'ForgotPassword',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data: () => ({
    email: '',
    action_running: false
  }),
  mounted() {
    $(document).on('keypress', (e) => {
      if (e.which === 13) {
        this.handle_enter_email();
      }
    });
  },
  methods: {
    handle_enter_email() {
      this.action_running = true;
      if (validate_email(this.email)) {
        sessionStorage.setItem('reset_email', this.email);
        axios
          .post(SEND_FORGOT_PASSWORD_EMAIL, { email: this.email })
          .then(() => {
            this.action_running = false;
            this.$router.push({
              path: '/reset_password_sent',
            });
          })
          .catch(() => {
            this.show_error('There was an error sending the email. Please try again.');
            this.action_running = false;
          });
      } else {
        this.show_error('Please enter a valid email address.');
        this.action_running = false;
      }
    },
  }
};
